import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type WorkspaceMembersListOrganizationFragment = (
  { __typename: 'Organization' }
  & Pick<Types.Organization, 'id' | 'idEnterprise' | 'offering'>
  & { enterprise?: Types.Maybe<(
    { __typename: 'Enterprise' }
    & Pick<Types.Enterprise, 'id' | 'displayName'>
  )> }
);

export const WorkspaceMembersListOrganizationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WorkspaceMembersListOrganization' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Organization' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'enterprise' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'idEnterprise' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offering' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseWorkspaceMembersListOrganizationFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      WorkspaceMembersListOrganizationFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseWorkspaceMembersListOrganizationFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<WorkspaceMembersListOrganizationFragment>,
    'data'
  > {
  data?: WorkspaceMembersListOrganizationFragment;
}

export const useWorkspaceMembersListOrganizationFragment = ({
  from,
  returnPartialData,
  ...options
}: UseWorkspaceMembersListOrganizationFragmentOptions): UseWorkspaceMembersListOrganizationFragmentResult => {
  const result = Apollo.useFragment<WorkspaceMembersListOrganizationFragment>({
    ...options,
    fragment: WorkspaceMembersListOrganizationFragmentDoc,
    fragmentName: 'WorkspaceMembersListOrganization',
    from: {
      __typename: 'Organization',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as WorkspaceMembersListOrganizationFragment,
  };
};
